module.exports = __webpack_public_path__ + "img/law1-m@2.df1bdef5.webp";